<template>
    <div id="about-us">

        <div class="hero">
            <p>Welcome to <br />Elite Craft Homes</p>
            <img src="../../../static/images/taft-about.jpg" alt="">
        </div>

        <h1>About Us</h1>

        <div class="navigation">
            <router-link :class="about.activeNav === 'whoweare' ? 'active nav_about__link' : 'nav_about__link'"
                         :to="{ name: 'WhoWeAre' }" @click="about.activeNav = 'whoweare'">Who We Are</router-link>
            <router-link :class="about.activeNav === 'testimonials' ? 'active nav_about__link' : 'nav_about__link'"
                         :to="{ name: 'Testimonials' }" @click="about.activeNav = 'testimonials'">Testimonials</router-link>
        </div>

        <div class="nav_small">
            <v-select :items="about.navItems" v-model="about.selectedMenu" item-text="name" item-value="id" auto
                      max-height="400" return-object outline @input="mapSmallNav"
                      :to="{ name: about.selectedMenu.id === 'testimonials' ? 'Testimonials' : 'WhoWeAre' }"></v-select>
        </div>

        <router-view></router-view>

    </div>
</template>

<script>
    const data = {
        about: {
            activeNav: '',
            navItems: [
                { name: 'Who We Are', id: 'whoweare' },
                { name: 'Testimonials', id: 'testimonials' }
            ],
            selectedMenu: { name: 'Who We Are', id: 'whoweare' }
        }
    };

    export default {
        name: 'About',
        data() {
            return data
        },
        methods: {
            mapSmallNav() {
                this.about.activeNav = this.about.selectedMenu;
                this.$router.push({ name: this.about.selectedMenu.id === 'testimonials' ? 'Testimonials' : 'WhoWeAre'})
            }
        }
    }
</script>

<style lang="scss" scoped>

    @font-face {
        font-family: "Tahu";
        src: url("https://elitecrafthomes.com/static_files/fonts/Tahu.ttf"),
        url("https://elitecrafthomes.com/static_files/fonts/Tahu.otf") format('opentype');
    }

    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
    }

    h1 {
        margin: 50px 0 70px 0;
        text-align: center;
        font-size: 30px;
        font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
    }

    p {
        font-size: 18px;
    }

    .nav_small {
        display: none;
    }

    .navigation {
        margin: 30px 0 55px 0;
        padding: 0;
        width: auto;
        text-align: center;
        .nav_about__link {
            margin: 0 25px;
            padding: 7px 0;
            display: inline-block;
            font-size: 24px;
            transition: ease-in-out 0.2s all;
            text-decoration: none;
            color: black;
            cursor: pointer;
            &hover {

            }
        }
        .router-link-active {
            font-weight: bold;
            border-top: 3px solid black;
            border-bottom: 3px solid black;
        }
    }

    .hero {
        position: relative;
        background-color: rgba(0, 0, 0, 0.65);
        width: 100%;
        height: 530px;
        max-height: 530px;
        max-width: 100vw;
        overflow: hidden;
        br {
            display: none;
        }
        p {
            font-size: 72px;
            font-family: "Tahu", cursive;
            color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            z-index: 899;
            padding-left: 25px;
            line-height: 1.4;
        }
        img {
            height: 530px;
            max-height: 530px;
            width: 100%;
            max-width: 100vw;
            position: absolute;
            top: 0;
            left: 0;
            object-fit: fill;
            opacity: .5;
            -webkit-transform: scaleY(1.3);
            -moz-transform: scaleY(1.3);
            -ms-transform: scaleY(1.3);
            -o-transform: scaleY(1.3);
            transform: scaleY(1.3);
        }
    }

    /* iPads (portrait) ----------- */
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        #app .wrapper {
            padding: 0 !important;
            margin: 0 auto;
        }

        .nav_small {
            display: none;
        }

        .navigation {
            display: block;
        }

        .hero {
            width: 100%;
            height: 500px;
            max-height: 500px;
            max-width: 100vw;
            br {
                display: block;
            }
            p {
                font-size: 3.5em;
                padding-left: 60px;
                line-height: 1.4;
                left: 0;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);
            }
            img {
                height: 500px;
                max-height: 500px;
            }
        }
    }

    /* Smartphones (portrait) ----------- */
    @media only screen and (max-width: 450px) {

        .nav_small {
            display: block;
            max-width: 70%;
            width: 70%;
            margin: 0 auto;
            .v-input__control {
                height: 40px;
                max-height: 40px;
            }
            .v-input.v-text-field.v-text-field--enclosed.v-text-field--outline.v-select {
                height: 60px;
                max-height: 60px;

            }
        }

        .navigation {
            display: none;
        }
        .emphasis {
            margin: 0 auto 20px auto;
            padding: 0;
            font-style: italic;
        }

        .hero {
            width: 100%;
            height: 430px;
            max-height: 430px;
            max-width: 100vw;
            overflow: hidden;
            br {
                display: block;
            }
            p {
                font-size: 3em;
                padding-left: 25px;
                line-height: 1.4;
                left: 0;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);
            }
            img {
                height: 430px;
                max-height: 430px;
                -webkit-transform: scaleX(1.8);
                -moz-transform: scaleX(1.8);
                -ms-transform: scaleX(1.8);
                -o-transform: scaleX(1.8);
                transform: scaleX(1.8);
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/about/About.vue